import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import { useToast } from '../contexts/ToastContext';

const EditProfileModal = ({ onClose }) => {
  const { user, setUser } = useUser();
  const [name, setName] = useState(user ? user.name : '');
  const [error, setError] = useState('');
  const { addToast } = useToast();

  useEffect(() => {
    if (user) {
      setName(user.name);
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const response = await fetch(`/api/v1/users/${user.id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      body: JSON.stringify({ user: { name } }),
    });

    const data = await response.json();

    if (response.ok) {
      setUser(data);
      addToast('Profile updated successfully!', 'success');
      onClose();
    } else {
      setError(data.errors ? data.errors.join(', ') : 'Update failed.');
    }
  };

  if (!user) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <article className="modal-content" onClick={(e) => e.stopPropagation()}>
        <header className="modal-header">
          <h2>Edit Profile</h2>
          <button aria-label="Close" className="close-button" onClick={onClose}>&times;</button>
        </header>
        <form onSubmit={handleSubmit}>
          {error && <p style={{ color: 'var(--pico-color-red-550)' }}>{error}</p>}
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <button type="submit">Save Changes</button>
        </form>
      </article>
    </div>
  );
};

export default EditProfileModal;